import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton } from '@/components';
import DetailCard from './DetailCard';

interface ObservationPanelProps {
  text: string;
  isSaving: boolean;
  disabled: boolean;
  onChange: (text: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
}

const ObservationPanel = ({
  text,
  isSaving,
  disabled,
  onChange,
  onCancel,
  onSubmit,
}: ObservationPanelProps) => (
  <DetailCard title='Devolver a comercial'>
    <textarea
      className='w-full rounded-md border border-gray-300 p-3 text-sm'
      rows={3}
      placeholder='Qué tiene que corregir o completar comercial'
      value={text}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
    />
    <div className='flex justify-end gap-2.5'>
      <GlobalButton variant={GlobalButtonVariant.textButton} action={onCancel} disabled={disabled}>
        Cancelar
      </GlobalButton>
      <GlobalButton
        variant={GlobalButtonVariant.primaryButton}
        action={onSubmit}
        disabled={disabled || !text.trim()}
      >
        {isSaving ? 'Guardando...' : 'Observar'}
      </GlobalButton>
    </div>
  </DetailCard>
);

export default ObservationPanel;
